module.exports = __webpack_public_path__ + "img/twitter_sign_in.6d8f2e79.svg";